import { observable, action } from "mobx";
import config from "../config";
import Http from "axios";

class UserStore {
  @observable
  user = {};

  @observable
  orders = [];

  @observable
  downloads = [];

  @observable
  selectedOrder = {};

  @action
  getMyOrders() {
    Http.get(config.api + "/orders", {
      withCredentials: true
    }).then(orders => {
      console.log(orders.data.result);
      this.orders = orders.data.result;
    });
  }

  @action
  getMyDownloads() {
    Http.get(config.api + "/orders/downloads", {
      withCredentials: true
    }).then(downloads => {
      console.log(downloads.data.result);
      this.downloads = downloads.data.result;
    });
  }

  @action
  getMyStats() {
    Http.get(config.api + "/me", { withCredentials: true }).then(user => {
      this.user = user.data.result;
    });
  }

  @action
  logout() {
    Http.post(config.api + "/logout", {}, { withCredentials: true }).then(
      user => {
        this.user = {};
      }
    );
  }

  @action setOrder(order) {
    this.selectedOrder = order;
  }

  @action async getOrder(orderId) {
    const { data } = await Http.get(`${config.api}/orders/${orderId}`, {
      withCredentials: true
    });
    this.setOrder(data.result);
  }
}

const user = new UserStore();

export default user;



// WEBPACK FOOTER //
// ./src/stores/UserStore.js